import React from 'react';
import {Table as BaseTable} from 'desktop/sports/cfb/players-list/single-game';

class Table extends BaseTable {}

export {Table};
